import React from 'react';
import './PropertyWizard.css';

/**
 * TabNavigation Component
 * 
 * Displays tabs for switching between different sections:
 * - My Agents
 * - Properties
 * - Sale Listings
 * - Rent Listings
 */
function TabNavigation({ activeTab, onTabChange, counts, isAgent }) {
  const tabs = [
    // Only show agent tab for owners, not for agents
    ...(!isAgent ? [{
      id: 'agents',
      label: 'نمایندگان من',
      count: counts.agents || 0
    }] : []),
    {
      id: 'properties',
      label: 'املاک من',
      count: counts.properties || 0
    },
    {
      id: 'sale',
      label: 'آگهی‌های فروش',
      count: counts.sale || 0
    },
    {
      id: 'rent',
      label: 'آگهی‌های اجاره',
      count: counts.rent || 0
    }
  ];

  return (
    <div className="tab-navigation">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="tab-label">{tab.label}</span>
          <span className="tab-count">({tab.count})</span>
        </button>
      ))}
    </div>
  );
}

export default TabNavigation;
